import { render } from "./DefaultSelect.vue?vue&type=template&id=c275e278&scoped=true"
import script from "./DefaultSelect.vue?vue&type=script&lang=js"
export * from "./DefaultSelect.vue?vue&type=script&lang=js"

import "./DefaultSelect.vue?vue&type=style&index=0&id=c275e278&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c275e278"]])

export default __exports__